export default __webpack_public_path__ + "static/media/green-dots.8d593ffd.svg";